export default __webpack_public_path__ + "static/media/Package.cbeef652.svg";